// PPS CRM - Login Page
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';
import logoDark from '../assets/brand/paradox-logo-transparent.png';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const login = useAuthStore((s) => s.login);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center login-shell">
      <div className="login-card">
        <div className="brand-panel">
          <img src={logoDark} alt="Paradox Payroll Systems" />
          <div className="brand-panel__tag">Paradox Payroll Systems</div>
        </div>

        <div className="login-body">
          <p className="text-sm mb-6" style={{ color: '#4B5563' }}>CRM Login</p>

          <form onSubmit={handleSubmit}>
          {error && (
            <div className="mb-4 p-3 rounded" style={{ backgroundColor: '#FEE2E2', color: '#991B1B', border: '1px solid #FCA5A5' }}>
              {error}
            </div>
          )}

          <div className="mb-4">
            <label className="block text-sm font-medium mb-2" style={{ color: '#374151' }}>
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-lg"
              style={{ border: '1px solid #D1D5DB', backgroundColor: '#F9FAFB' }}
              placeholder="you@example.com"
              required
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium mb-2" style={{ color: '#374151' }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-lg"
              style={{ border: '1px solid #D1D5DB', backgroundColor: '#F9FAFB' }}
              placeholder="********"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-lg font-semibold transition-all"
            style={{ 
              backgroundColor: 'var(--primary)', 
              color: '#fff',
              border: '1px solid var(--primary)'
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

          <div className="mt-6 text-center">
            <p className="text-sm" style={{ color: '#6B7280' }}>
              Protected by secure encryption
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
